export const UPDATE_MODEL_EVENT = 'update:modelValue'
export const CHANGE_EVENT = 'change'
export const INPUT_EVENT = 'input'
export const basePrefixCls = 'sc'
export const PAGE_SIZE = 10
export const ROW_KEY = 'key'
export const SELECTION_ROW_KEY = 'selectionRowKey'
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 80, 100]
export const FETCH_SETTING = {
  pageField: 'current',
  sizeField: 'size',
  listField: 'records',
  totalField: 'total',
}